export default __webpack_public_path__ + "06c8a157cfc33c09a1558df899270e8b.png";